import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { AuthService, UserSession } from '../../core/services/auth.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-app-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, TooltipModule],
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.css']
})
export class AppLayoutComponent {
  isCollapsed = false;
  currentUser$: Observable<UserSession | null>;

  menuItems = [
    { label: 'Dashboard', icon: 'pi pi-home', route: '/dashboard' },
    { label: 'Empresas', icon: 'pi pi-building', route: '/empresas' },
    { label: 'Comprobantes', icon: 'pi pi-file', route: '/comprobantes' },
    { label: 'Usuarios', icon: 'pi pi-users', route: '/usuarios' },
    { label: 'Correlativos', icon: 'pi pi-cog', route: '/correlativos' },
  ];

  constructor(private authService: AuthService) {
    this.currentUser$ = this.authService.currentUser$;
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  logout() {
    this.authService.logout();
  }
}

